const DB_NAME = 'spx-playback-checkpoints';
const STORE_NAME = 'recordings';
const CHECKPOINT_KEY = 'latest';

let checkpointDriver = createIndexedDbDriver();

function createIndexedDbDriver() {
  return {
    async load() {
      const db = await openDb();
      return withStore(db, 'readonly', (store) => store.get(CHECKPOINT_KEY));
    },
    async save(value) {
      const db = await openDb();
      return withStore(db, 'readwrite', (store) => store.put(value, CHECKPOINT_KEY));
    },
    async clear() {
      const db = await openDb();
      return withStore(db, 'readwrite', (store) => store.delete(CHECKPOINT_KEY));
    },
  };
}

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB unavailable.'));
      return;
    }
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error('IndexedDB open failed.'));
  });
}

function withStore(db, mode, run) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    const req = run(store);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error('IndexedDB request failed.'));
    tx.onabort = () => reject(tx.error || new Error('IndexedDB transaction aborted.'));
    tx.onerror = () => reject(tx.error || new Error('IndexedDB transaction failed.'));
  });
}

export async function loadPlaybackCheckpoint() {
  return checkpointDriver.load();
}

export async function savePlaybackCheckpoint(value) {
  return checkpointDriver.save(value);
}

export async function clearPlaybackCheckpoint() {
  return checkpointDriver.clear();
}

export function __setPlaybackCheckpointDriver(driver) {
  checkpointDriver = driver;
}
